import React from 'react'

import { replaceTags } from '.'
import type { ComparisonTableProps } from '../components/ComparisonTable/types'
import type { ComparisonTableType } from '../data'
import { parseJSONDataFromContentful } from './parseJSONDataFromContentful'

export function transformToComparisonTableData(
  data: Record<string, unknown>,
  key?: string
): ComparisonTableProps {
  // @ts-expect-error - This data needs to be parsed with Zod ECP-13033
  const comparisonTableData: ComparisonTableType['comparisonTable']['content'] =
    !!key
      ? parseJSONDataFromContentful(data, key)
      : (data as ComparisonTableType['comparisonTable']['content'])

  return {
    ...comparisonTableData,
    footer: (
      <span>
        {comparisonTableData.footer.map((str, index) => (
          <span className="mt-2 block" key={index}>
            {replaceTags(str)}
            <br />
          </span>
        ))}
      </span>
    )
  }
}
